import DashboardUserHeading from '../../atoms/dashboard-user-heading/DashboardUserHeading';
import { AuthenticatedUser, useAuth } from 'auth';
import { BreakpointProvider } from '../../../../../providers/breakpoint/BreakpointProvider';
import GridLayoutShell from '../../organisms/grid-layout/GridLayoutShell';

export const IntermediaryDashboard = () => {
  const authApi = useAuth();
  const currentSignedInUser: AuthenticatedUser | undefined = authApi.getSignedInUser();
  const getLoggedInUserName = (): string => currentSignedInUser?.fullName ?? '';
  return (
    <BreakpointProvider>
      <div>
        <DashboardUserHeading type='intermediary' user={getLoggedInUserName()} />

        <GridLayoutShell pageType='intermediary' />
      </div>
    </BreakpointProvider>
  );
};
